<script lang="ts">
  import { onMount } from 'svelte';

  onMount(() => {
    const SECTIONS = {
      OMNICHANNEL: 'omnichannel',
      TESTIMONIAL_CAROUSEL: 'testimonial carousel',
      OPTIMIZE: 'optimize operations',
      TESTIMONIALS_LINK: 'testimonials link',
      VPOS_BANNER: 'vpos banner',
      FLOW_CHART: 'flow chart',
    };
    const TAB_NAMES = {
      VERTICAL_0: 'all',
      VERTICAL_1: 'restaurant',
      VERTICAL_2: 'retail',
      VERTICAL_3: 'beauty',
    };
    const SELECTORS = {
      TAB_PANEL: '.tabPanel',
      TAB_WRAPPER: '.tabPanelsWrapper',
      BLUESKY_OMNICHANNEL: '.ThreeColVideoSequence',
      SHIBUYA_OMNICHANNEL: '.HomePageHorizontalStoryCustomSection',
      TESTIMONIAL_CAROUSEL: '.SellerProofCarousel',
      OPTIMIZE: '.HomePageProductCombos',
      TESTIMONIALS_LINK: '.sq-custom-testimonials-link',
      VPOS_BANNER: '.sq-custom-vpos-banner',
      FLOW_CHART: '.sq-custom-flow-chart-text',
    };
    const tabNames = [TAB_NAMES.VERTICAL_0, TAB_NAMES.VERTICAL_1, TAB_NAMES.VERTICAL_2, TAB_NAMES.VERTICAL_3];

    // set a unique id for a section based on the vertical tab it's in
    const setSectionId = (el: Element, sectionName: string) => {
      const tab = el.closest(SELECTORS.TAB_PANEL);
      const tabHolder = el.closest(SELECTORS.TAB_WRAPPER);
      if (tab && tabHolder) {
        const tabIndex = Array.prototype.findIndex.call(tabHolder.children, (c) => c === tab);
        el.id = `${tabNames[tabIndex]} - ${sectionName}`;
      }
    };

    // bluesky omnichannel (sell everywhere) - three videos
    const blueskyOmnichannels = document.querySelectorAll(SELECTORS.BLUESKY_OMNICHANNEL);
    blueskyOmnichannels.forEach((el) => {
      setSectionId(el, SECTIONS.OMNICHANNEL);
    });

    // shibuya omnichannel (sell everywhere) - horizontal scroll
    const shibuyaOmnichannels = document.querySelectorAll(SELECTORS.SHIBUYA_OMNICHANNEL);
    shibuyaOmnichannels.forEach((el) => {
      setSectionId(el, SECTIONS.OMNICHANNEL);
    });

    // vpos banner
    const vposBanner = document.querySelectorAll(SELECTORS.VPOS_BANNER);
    vposBanner.forEach((el) => {
      setSectionId(el, SECTIONS.VPOS_BANNER);
    });

    // testimonial carousel
    const testimonialCarousels = document.querySelectorAll(SELECTORS.TESTIMONIAL_CAROUSEL);
    testimonialCarousels.forEach((el) => {
      setSectionId(el, SECTIONS.TESTIMONIAL_CAROUSEL);
    });

    // optimize (connected and comprehensive)
    const optimize = document.querySelectorAll(SELECTORS.OPTIMIZE);
    optimize.forEach((el) => {
      setSectionId(el, SECTIONS.OPTIMIZE);
    });

    // testimonials link (hear from square sellers)
    const testimonialLinks = document.querySelectorAll(SELECTORS.TESTIMONIALS_LINK);
    testimonialLinks.forEach((el) => {
      setSectionId(el, SECTIONS.TESTIMONIALS_LINK);
    });

    // flow chart text
    const flowChart = document.querySelectorAll(SELECTORS.FLOW_CHART);
    flowChart.forEach((el) => {
      setSectionId(el, SECTIONS.FLOW_CHART);
    });
  });
</script>
